import { render, staticRenderFns } from "./CustomerTrainingCard.vue?vue&type=template&id=a8332cc8&"
import script from "./CustomerTrainingCard.vue?vue&type=script&lang=js&"
export * from "./CustomerTrainingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports